import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import FontSizeControls from "./FontSizeControls";

const items = [
  { to: '/', key: 'home', fallback: 'Bosh sahifa', end: true },
  { to: '/Products', key: 'products', fallback: 'Mahsulotlar' },
  { to: '/Services', key: 'services', fallback: 'Xizmatlar' },
  { to: '/About', key: 'about', fallback: 'Biz haqimizda' },
  { to: '/Contact', key: 'contact', fallback: 'Aloqa' },
];

export default function Navbar() {
  const { t, i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const changeLanguage = (lng) => { i18n.changeLanguage(lng); setOpen(false); };
  return <header className="site-header">
    <div className="topline"><div className="site-container topline-inner"><span><i className="status-dot" /> Onlayn kassa va savdo uskunalari bo‘yicha ishonchli hamkor</span><div className="topline-contact"><a href="tel:+998997055375">+998 99 705 53 75</a><span>·</span><a href="mailto:info@navoietm.uz">info@navoietm.uz</a></div></div></div>
    <nav className="main-nav"><div className="site-container nav-inner">
      <Link className="brand" to="/" onClick={() => setOpen(false)}><span className="brand-mark"><img src="/images/logo.png" alt="" /></span><span className="brand-copy"><strong>{t('siteTitle','NAVOI ETM')}</strong><small>NAVOIY KOMPYUTER SPEKTR</small></span></Link>
      <button className="mobile-menu-toggle" onClick={() => setOpen(!open)} aria-label={open ? 'Menyuni yopish' : 'Menyuni ochish'} aria-expanded={open}><span/><span/><span/></button>
      <div className={`nav-content ${open ? 'nav-content-open' : ''}`}><div className="nav-links">{items.map(item => <NavLink key={item.to} to={item.to} end={item.end} onClick={() => setOpen(false)} className={({isActive}) => `nav-link${isActive ? ' nav-link-active' : ''}`}>{t(`navbar.${item.key}`,item.fallback)}</NavLink>)}</div>
        <div className="language-switch" aria-label="Tilni tanlang">{['uz','ru','en'].map(lng => <button key={lng} onClick={() => changeLanguage(lng)} className={i18n.language?.startsWith(lng) ? 'language-active' : ''} aria-pressed={i18n.language?.startsWith(lng)}>{lng.toUpperCase()}</button>)}</div>
        <FontSizeControls />
        <Link to="/Contact" className="nav-cta" onClick={() => setOpen(false)}>{t('navbar.contact','Bog‘lanish')} <span>↗</span></Link>
      </div>
    </div>
    </nav>
  </header>;
}
